import { yupResolver } from "@hookform/resolvers/yup"
import React, { useState, useEffect } from "react"
import { FormProvider, useForm } from "react-hook-form"
import {
  Row,
  Col,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  FormFeedback,
  Spinner,
  Form,
  FormGroup,
  Label,
  Button
} from "reactstrap"
import * as yup from "yup"
import LoadingButton from "../../../components/Common/LoadingButton"
import { UFInput } from "../../../components/Common/Fields/Input"
import classnames from "classnames"
import { Link } from "react-router-dom"
import { toastError, toastSuccess } from "../../../helpers/msg_helper"
import { postSettingsLocation } from "../../../services/Settings/settings"

const Locationschema = yup.object().shape({
  name: yup.string().required("Location is Required"),
})

const Edit = ({ loading, onUpdate, id, error, close, editItem, ...props }) => {
  const formMethods = useForm({
    resolver: yupResolver(Locationschema),
    mode: "onChange",
    shouldFocusError: true,
  })
  
  const {
    control,
    handleSubmit,
    formState: { errors },
    reset,
  } = formMethods;
  
  const [isLoading, setIsLoading] = useState(false)

  // useEffect(() => {
  //   if (props?.editItem?.modal) {
  //     reset({
  //       ...props?.editItem?.value,
  //     })
  //   }
  // }, [props?.editItem?.modal])

  useEffect(() => {
    if (editItem?.modal && editItem?.value) {
      reset({
        name: editItem?.value?.name || "",
      })
    } else {
      reset({ name: "" }) // Reset form when not in edit mode
    }
  }, [editItem?.modal, editItem?.value, reset])

  const handleSeriesAdd = async data => {
    try {
      setIsLoading(true)
      const payload = {
        name: data.name,
        ...(editItem?.modal && { id: editItem?.value?.id })
      }
      const createdSeries = await postSettingsLocation(payload)
      toastSuccess(createdSeries?.message)
      onUpdate?.(createdSeries?.data);
    } catch (err) {
      toastError(err?.message)
    } finally {
      setIsLoading(false)
      // reset()
      reset({ name: "" })
      close()
    }
  }

  return (
    <>
      <OffcanvasHeader toggle={close}>
        <div className="d-flex justify-content-between">
          <h5>{editItem?.modal ? "Edit Location" : "Add Location"}</h5>
          <div className="d-flex gap-2">
            <Button
              type="button"
              color="secondary"
              // onClick={close}
              onClick={() => {
                reset({ name: "" });
                close();
              }}
            >
              Cancel
            </Button>
            <LoadingButton
              form="location-form"
              color="primary"
              loading={isLoading}
              disabled={isLoading}
              type="submit"
            >
              {editItem?.modal ? "Update" : "Save"}
            </LoadingButton>
          </div>
        </div>
      </OffcanvasHeader>
      {loading ? (
        <div
          className="px-8"
          style={{
            width: "100%",
            textAlign: "center",
            minHeight: "200px",
            paddingTop: "90px",
          }}
        >
          <Spinner
            className={classnames({
              "mx-2": true,
              "position-relative": true,
              visible: true,
            })}
            size="lg"
          />
        </div>
      ) : (
        <OffcanvasBody>
          <FormProvider {...formMethods}>
            <Form id="location-form" onSubmit={(e) => {  e.preventDefault();
          e.stopPropagation();
          handleSubmit(handleSeriesAdd)(e) }}>
              <Row>
                <Col sm={12}>
                  <FormGroup className="mb-4">
                    <Label>
                      Location<span className="mandatory">*</span>
                    </Label>
                    <UFInput
                      control={control}
                      placeholder="Enter the location"
                      name="name"
                      invalid={!!errors.name}
                    />
                    <FormFeedback invalid>
                      {errors.name?.message}
                    </FormFeedback>
                  </FormGroup>
                </Col>
              </Row>
            </Form>
          </FormProvider>
        </OffcanvasBody>
      )}
    </>
  )
}

const EditLocation = ({ buttonLabel, className, isOpen, onClose,onCustomerCreated,editValue, ...props }) => {
  const [offcanvas, setOffcanvas] = useState(false)
  const [getEditValue, setGetEditValue] = useState("");
  const [customers, setCustomers] = useState([]);

  const handleSuccess = (data) => {
    onCustomerCreated?.(data); // Call this when customer is successfully created
    onClose?.();
  };

  const toggle = () => {
    if (isOpen !== undefined) {
      onClose?.()
    } else {
      setOffcanvas(!offcanvas)
    }
  }

  useEffect(() => {
    if (props?.editItem?.modal) {
      toggle()
    }
  }, [props?.editItem?.modal])

  const isOpenState = isOpen !== undefined ? isOpen : offcanvas

  return (
    <>
      <Link to="#" className={className} onClick={toggle}>
        {buttonLabel}
      </Link>
      <Offcanvas 
        isOpen={isOpenState} 
        toggle={toggle} 
        direction="end"
        className="w-of-40  width-of-custom"
        backdrop={false}
        keyboard={false}
      >
        <Edit
          close={() => {
            toggle()
            setGetEditValue("");
            props?.onReset?.()
          }}
           getEditValue={getEditValue}
          onUpdate={handleSuccess}
          editItem={props.editItem}
          {...props}
        />
      </Offcanvas>
    </>
  )
}

export default EditLocation